import { Check } from 'lucide-react';

/**
 * SareeBlouseGate — Step 00 for the Ready-to-Wear Saree category.
 * User must pick "with/without blouse" before the Style step reveals design fields.
 * Answer is stored on `preferences.with_blouse` (single source of truth).
 */
export default function SareeBlouseGate({ value, onChange }) {
  const current = value?.value;
  const pick = (v) => {
    // boolean_with_comment shape — matches backend `with_blouse` preference field
    onChange({ value: v });
  };

  return (
    <div data-testid="saree-blouse-gate" className="mb-10 border-b border-border pb-10">
      <div className="uppercase tracking-luxe text-[11px] font-semibold text-gold mb-3">
        Step 00 · Blouse
      </div>
      <h2 className="font-display font-light text-ink leading-none tracking-[-0.015em] mb-3" style={{ fontSize: 'clamp(30px, 4vw, 44px)' }}>
        Do you want a matching blouse?
      </h2>
      <p className="text-sm text-ink-muted mb-6 max-w-2xl">
        Ready-to-wear sarees can be stitched with a matching blouse or as saree only. This choice controls whether neck &amp; sleeves designs (and blouse-specific preferences) appear in the following steps.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl">
        {[
          { key: 'yes',  title: 'Yes, include a blouse', sub: 'Pick neck, sleeves and blouse preferences in later steps.' },
          { key: 'no',   title: 'Saree only',            sub: 'No blouse. Neck & sleeves selections will be skipped.' },
        ].map(opt => {
          const selected = current === opt.key;
          return (
            <button
              key={opt.key}
              onClick={() => pick(opt.key)}
              className={`text-left p-5 border transition-all ${selected ? 'border-ink outline outline-1 outline-offset-4 outline-ink bg-secondary/40' : 'border-border hover:border-ink/60'}`}
              data-testid={`saree-blouse-${opt.key}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="font-display text-ink" style={{ fontSize: 20 }}>{opt.title}</p>
                  <p className="text-xs text-ink-muted mt-1.5 leading-relaxed">{opt.sub}</p>
                </div>
                {selected && (
                  <div className="w-7 h-7 rounded-full bg-ink text-background flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5" strokeWidth={1.5} />
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
